/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import RadarChartRecharts from 'components/radarChart'
import { Link } from '@ta-interaktiv/contentbricks'
import Testimonial from '../../components/testimonial'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Accordion } from 'semantic-ui-react'
import Methodic from 'components/methodic'
import InlineAccordion from 'components/inlineAccordion'

// TODO Set the correct article ID here
const ARTICLE_ID = '748255680596'

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: [-1]
    }
  }

  render() {
    const Image = ({ imgSrc }) => (
      <>
        <img
          src={require('../../images/' + imgSrc)}
          className='ui fluid image'
        />
      </>
    )

    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>So verändern die Frauen das Bundeshaus</h1>
              <h2>
                Noch nie sassen so viele Frauen im eidgenössischen Parlament wie
                heute. Abstimmungen, Reden, Themen: Eine grosse Datenanalyse
                zeigt, wie diese historische Höchstzahl die Politik konkret
                beeinflusst.
              </h2>
            </div>
          </div>
        </header>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Salome Müller, Raphaela Birrer, Sven Cornehls, Patrick Meier,
                Patrick Vögeli
              </div>
              <div className='ta updated'>Aktualisiert am 6. Februar 2021</div>
            </div>
            <div className='ta text'>
              <p>
                Fast fünfzig Jahre für 42 Prozent. Auch nach der Annahme des
                Frauenwahlrechts blieb das Bundeshaus lange in Männerhand. Der
                Wahlherbst 2019 änderte dies schlagartig: Noch nie wurden so
                viele Frauen gewählt. Seither besetzen sie 42 Prozent der Sitze
                in der grossen und 26 Prozent der Sitze in der kleinen Kammer.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui container'>
            <div className='ui two column grid doubling stackable'>
              <div className='row'>
                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      Entwicklung des Frauenanteils im Parlament
                    </h4>
                    <div className='graphicSub'>
                      In Prozent nach eidgenössischen Wahlen
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/urB2C/'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>Frauenanteil nach Fraktion</h4>
                    <div className='graphicSub'>
                      Geschlechteranteil Nationalrat 2019
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='https://datawrapper.dwcdn.net/vCjRy/'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Wie verändert dieser historische Höchststand des Frauenanteils
                die Politik? Eine Datenanalyse in drei Punkten zeigt, was die
                Politikerinnen in Bundesbern konkret bewirkt haben.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            {/* <p>
                <Link href='#methodic' hideIcon target='_parent'>
                  Methodik
                </Link>
              </p> */}
            <Testimonial
              imageSrc={<Image imgSrc='corina-gredig.png'></Image>}
              quote={
                '«Je mehr Frauen anwesend sind, desto weniger spielt ihr Geschlecht eine Rolle.»'
              }
              name={'Corina Gredig'}
              party={'GLP, ZH'}
              note={'Die Vernetzerin'}
              positionImage={'left'}
              personInfo={
                'Corina Gredig ist es wichtig, dass sich Parlamentarierinnen miteinander vernetzen – wie Männer dies schon lange tun. Sie hat den FC Helvetia gegründet und arbeitet im Parlament mit Frauen anderer Parteien zusammen, etwa beim Grossprojekt Individualbesteuerung. Gredig beobachtet eine Frauensolidarität: Parlamentarierinnen beziehen sich in ihren Voten explizit aufeinander. Und sie setzen sich gemeinsam dafür ein, dass auch Expertinnen in die Kommissionen eingeladen werden, nicht nur Experten.'
              }
            />
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>1</b>
                <br />
                Ja oder Nein? So verändern die Frauen die Abstimmungsresultate
              </h4>{' '}
              <p>
                84 Frauen politisieren seit dem Wahlherbst 2019 im Nationalrat –
                das sind 20 mehr als in der vorangegangenen Legislatur. Lässt
                das neue Geschlechterverhältnis die Mehrheiten kippen? Um diese
                Frage zu beantworten, muss man das neue über das alte Parlament
                legen: Werden alle Abstimmungen der letzten Legislatur
                entsprechend der Zusammensetzung des 2019 gewählten Nationalrats
                neu simuliert, zeigt sich: 350 von 3535 Abstimmungen wären
                anders herausgekommen.
              </p>
              <p>
                Doch bei keiner dieser Abstimmungen war der Frauenanteil
                innerhalb der Parteien ausschlaggebend für das andere Resultat.
                Dass zehn Prozent der Geschäfte mit der neuen Konstellation im
                Nationalrat gekippt wären, ist stattdessen auf die veränderten
                Parteienstärken zurückzuführen.
              </p>
              <InlineAccordion
                text={
                  <div>
                    <div>
                      <b>Zum Beispiel der Ärztestopp:</b> Im Dezember 2015
                      setzte sich eine rechtsbürgerliche Mehrheit im Nationalrat
                      äusserst knapp gegen Mitte-links durch. SVP und FDP
                      lehnten es ab, eine bedarfsabhängige
                      Zulassungsbeschränkung für Ärzte definitiv ins Gesetz zu
                      schreiben. In der aktuellen Legislatur wäre diese Revision
                      wegen der erstarkten Grünen, die sie befürwortet haben,
                      durchgekommen.
                    </div>
                    <div style={{ marginTop: '1rem' }}>
                      <b>Oder die steuerlichen Privilegien für Bauern:</b> Im
                      April 2016 wollte der Nationalrat mit Stimmen von
                      Mitte-rechts den Landwirten die Bundessteuern für Gewinne
                      aus Baulandverkäufen erlassen. Nach hitzigen Debatten
                      revidierte er später seinen Entscheid. Mit der neuen
                      Zusammensetzung hätte der Nationalrat bereits im ersten
                      Anlauf Nein gesagt – weil die Grünen stärker und die SVP
                      schwächer geworden ist.
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        </div>

        <div className='ui text container'>
          <div className='column special'>
            <div className='titleBox'>
              <h4 className='graphicTitle'>
                Bei diesen Vorlagen gab es einen Geschlechtergraben
              </h4>
              <div className='graphicSub'>
                <div>
                  Aufgelistet sind jene neun Abstimmungen, bei denen die Summe
                  der Diskrepanzen über alle Fraktionen am höchsten ist (da die
                  GLP die kleinste Fraktion ist, wurde sie nicht
                  berücksichtigt). Gezeigt werden Anteil Ja-Stimmen. Fraktionen,
                  die nicht aufgeführt sind, haben vollständig oder
                  grösstenteils geschlossen abgestimmt (weniger als 10%
                  Diskrepanz).
                </div>
                <div style={{ marginTop: '0.5rem' }}>
                  <span className='bold'>Lesebeispiel:</span> Bei der
                  Schlussabstimmung zur Ehe für alle haben 71% der Frauen der
                  Mitte Ja gestimmt, aber nur 37% der Männer derselben Fraktion
                  sagten Ja.
                </div>
              </div>
              <div></div>
            </div>
            <div className='graphicBox'>
              {/* <div className='boxWrapper Abstimmungen'>
              <div className='iframeBox Abstimmungen'> */}
              <AutofitIFrame
                src='https://datawrapper.dwcdn.net/S219M/'
                // style={{ height: '98%' }}
              />
            </div>
          </div>
          {/* <div className='source'>
              Bei den nicht aufgeführten Fraktionen waren die Vorlagen
              vollständig oder grösstenteils unbestritten. Berücksichtigt wurden
              alle Schluss- und Gesamtabstimmungen der 51. Legislatur.
            </div> */}
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Trotzdem setzen die Parlamentarierinnen geschlechtsspezifische
                Akzente. Die systematische Analyse der 271 bisherigen Gesamt-
                und Schlussabstimmungen dieser Legislatur zeigt, in welchen drei
                Bereichen sie von der Haltung ihrer männlichen Parteikollegen
                abweichen.
              </p>
              <h5 className='inlineTitle'>Gesellschaftspolitik</h5>
              <p>
                Sollen Homosexuelle heiraten dürfen? Diese Frage spaltet die
                Frauen und Männer in den konservativen Parteien. So haben der
                Ehe für alle in der SVP 45 Prozent der Nationalrätinnen, aber
                nur 18 Prozent der Nationalräte zugestimmt. Auch in der
                Mitte-Fraktion stimmen der Homosexuellen-Ehe zwei Drittel der
                Frauen, aber nur ein Viertel der Männer zu. Dasselbe Muster
                zeigt sich in den beiden Fraktionen auch bei der Frage, ob
                Transsexuelle ihr Geschlecht sowie ihren Vornamen im
                Personenstandsregister ändern dürfen.
              </p>
              <p>
                In der CVP hat diese Diskrepanz eine lange Tradition: Die
                Frauensektion gehörte immer dem linken, liberalen Flügel der
                Partei an und kämpfte mal mehr, mal weniger laut gegen die
                konservativen Ansichten der männlichen Parteivertreter aus den
                Stammlanden. In der SVP ist es vorab eine jüngere
                Politikerinnengeneration, die teilweise progressivere Positionen
                vertritt. Dabei zeigt sich gemäss Lukas Golder, Co-Leiter von
                GFS Bern, in der SVP ein neues Muster: Nach dem Wegbruch der BDP
                musste sich in der Fraktion eine neue Generation von Frauen
                durchsetzen, die nun konservative Haltungen mit postmateriellen
                Werten wie eben einer hohen Gewichtung individueller Freiheiten
                verknüpft.
              </p>
            </div>
          </div>
        </div>
        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <Testimonial
              imageSrc={<Image imgSrc='marianne-binder-keller.png'></Image>}
              quote={
                '«Frauen in der Mitte sind sehr offen. Dies wird jetzt sichtbar.»'
              }
              name={'Marianne Binder-Keller'}
              party={'Mitte, AG'}
              note={'Präsente Mitte-Frau'}
              positionImage={'right'}
              personInfo={
                'Marianne Binder-Keller engagiert sich für die Burkainitiative, und zwar aus frauenrechtlichen Gründen, wie sie sagt. In der Fraktion gebe es bei gesellschaftspolitischen Vorlagen keine spezifischen Erwartungen. In ihrer Partei hätten Frauen in gesellschaftsliberalen Fragen schon immer eine wichtige Rolle gespielt. Und obwohl Binder-Keller nicht schubladisieren will, sagt sie: «Weil jetzt insgesamt auch mehr bürgerliche Frauen im Parlament sitzen, manifestiert sich diese neue Offenheit auch bei den Abstimmungen.»'
              }
            />
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Was bedeutet liberale Drogenpolitik? In der FDP sind die
                Pilotversuche zur kontrollierten Abgabe von Cannabis umstritten.
                90 Prozent der Frauen, aber nur 59 Prozent der Männer in der
                Fraktion waren dafür. Auch das ist typisch: Die FDP-Frauen sind
                traditionell progressiver als die Männer.
              </p>
              <p>
                Ein Sonderfall ist die Burkainitiative, über die wir demnächst
                abstimmen. Besonders gross war der Unterschied bei den Grünen.
                Ein Drittel der Männer, aber keine Frau sprach sich dort für
                einen Gegenvorschlag aus, weil es keinen Handlungsbedarf gebe.
                In der Mitte und der FDP war es genau umgekehrt: Dort fanden vor
                allem die Frauen, ein Gegenvorschlag mache Sinn, während die
                Männer zurückhaltender waren. Der Grund: «Je weiter links, desto
                zentraler ist die Genderfrage für die Frauen, desto
                kompromissloser politisieren sie in diesem Bereich», beobachtet
                Golder.
              </p>
              <h5 className='inlineTitle'>Sozial- und Bildungspolitik</h5>
              <p>
                Sollen Kinder bereits vor dem Kindergarten staatlich gefördert
                werden? Und sollen ältere Arbeitslose eine Überbrückungsrente
                erhalten? In den Parteien rund um die Mitte unterscheiden sich
                die Haltungen zwischen den Geschlechtern auch in bildungs- und
                sozialpolitischen Fragen. Die Frauen stimmen in diesen Bereichen
                häufiger mit der linken Ratsseite als die Männer. «Frauen
                erkennen wegen der Erziehungsarbeit und weil sie vermehrt in der
                Bildung und dem Sozialwesen beruflich tätig sind, mehr
                Handlungsbedarf als Männer», sagt Golder.
              </p>
              <h5 className='inlineTitle'>Umweltpolitik</h5>
              <p>
                Sollen in der Schweiz strengere Vorgaben gelten, um den
                CO₂-Verbrauch zu senken? Und sollen die Umweltauflagen für
                Wasserkraftwerke gelockert werden? Diese beiden Abstimmungen
                offenbaren einen Graben in der FDP. FDP-Chefin Petra Gössi hat
                mit ihrem Ziel, die Partei grüner zu machen, die Frauen in der
                Fraktion besser erreicht als die Männer. 100 Prozent der Frauen
                stimmten der Revision des CO₂-Gesetzes zu, bei den Männern waren
                es 82 Prozent.{' '}
              </p>
            </div>
          </div>
        </div>

        <div className='ui text container'>
          <div className='column special'>
            <div className='titleBox'>
              <h4 className='graphicTitle'>
                Geschlechter&shy;unterschied innerhalb der Fraktionen
              </h4>
              <div className='graphicSub'>
                Durchschnittlicher Unterschied zwischen Ja-Stimmen der Frauen
                und Männer derselben Fraktion in der 51. Legislatur
              </div>
            </div>
            <div className='graphicBox'>
              <div className='boxWrapper'>
                <div className='iframeBox'>
                  <AutofitIFrame
                    src='https://datawrapper.dwcdn.net/tz5c7/'
                    style={{ height: '100%' }}
                  />
                </div>
              </div>
              <div className='source'>
                Bisher gab es in der 51. Legislatur 271 Schluss- und
                Gesamtabstimmungen. Für jede Fraktion wurden jene Abstimmungen
                berücksichtigt, bei denen mehr als 90% der Fraktionsmitglieder
                eine valide Stimme (Ja oder Nein) abgegeben haben.
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'></div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>2</b>
                <br />
                Minuten oder Stunden? So verändern Frauen die Redezeiten
              </h4>{' '}
              <p>
                Wie lange reden Nationalrätinnen? Und wie verhält sich ihre
                Redezeit im Vergleich zu den Männern? Eine Analyse der
                Transkriptionen aller Wortmeldungen der vergangenen zwanzig
                Jahre zeigt: Frauen reden im Nationalrat länger als Männer –
                durchschnittlich 14,2 Minuten pro Session (Männer: 12,8
                Minuten).
              </p>
              <p>
                Dabei zeigt sich eine Entwicklung: Je mehr Frauen im Nationalrat
                sitzen, desto kürzer wird ihre durchschnittliche Sprechzeit. Sie
                hat sich über die Jahre hinweg jener der Männer angeglichen. Am
                besten kennen die jeweiligen Ratspräsidenten das Redeverhalten
                im Nationalrat – sie müssen allen Voten zuhören. Die heutige
                Ständerätin Marina Carobbio (SP) hatte dieses Amt 2018/19 inne.
                Sie sagt: «Weil es früher weniger Nationalrätinnen gab, nutzten
                sie die Zeit länger, wenn sie das Wort hatten.» Carobbio hat
                einen Unterschied in der Rhetorik der Geschlechter beobachtet:
                «Nationalrätinnen wiederholen die Aussagen ihrer Vorredner
                tendenziell weniger als Nationalräte, sie sprechen dann, wenn
                sie neue, eigene Gedanken haben.»
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <Testimonial
              imageSrc={<Image imgSrc='leonore-porchet.png'></Image>}
              quote={
                '«Als Grüne bin ich Teil der Opposition. Es gibt viel zu tun.»'
              }
              name={'Léonore Porchet'}
              party={'Grüne, VD'}
              note={'Linke Wortführerin'}
              positionImage={'left'}
              personInfo={
                'Léonore Porchet ist eine klassische Linkspolitikerin. Sie engagiert sich gegen jegliche Form von Diskriminierung und setzt sich für Minderheiten ein – etwa dafür, dass gehörlose Menschen Zugang zu politischen Informationen haben. Porchet ist eine der neu gewählten Frauen, die sich oft zu Wort melden: redegewandt, schnell – und auf Französisch. Porchet verzeichnet seit ihrer Wahl 70 Wortmeldungen. Dies hat damit zu tun, dass sie in zwei Kommissionen sitzt, als Geschäfts- und Fraktionssprecherin auftritt und mit persönlichen Voten gleichstellungspolitische Debatten vorantreiben will.'
              }
            />
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Trotz der längeren individuellen Redezeiten der Frauen redeten
                die Männer in den vergangenen zwanzig Jahren in der Summe
                länger. Gesamthaft beanspruchten sie eine doppelt so lange
                Redezeit, auch wenn ihre einzelnen Voten kürzer dauerten als
                jene der Frauen. Die Gesamtdauer der Wortmeldungen von Männern
                beträgt durchschnittlich 29,9 Stunden pro Session, jene von
                Frauen 14 Stunden.
              </p>
              <p>
                Obwohl die gesamthafte Redezeit der Frauen mit den Jahren
                zugenommen hat, bleibt eine grosse Differenz zu den Männern. Im
                vergangenen Jahr haben Männer in der Summe siebeneinhalb Stunden
                länger geredet als Frauen.
              </p>
              <p>
                Das liegt zum einen an ihrer Überzahl, zum anderen aber auch an
                ihren Rollen: Männer sind immer noch häufiger Kommissions- oder
                Fraktionssprecher als Frauen, weil diese Funktionen
                Parlamentariern vorbehalten sind, die erfahrener sind und die
                Geschäfte besser kennen.{' '}
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui container'>
            <div className='ui two column grid doubling stackable'>
              <div className='row'>
                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      So lange redet eine Nationalrätin
                    </h4>
                    <div className='graphicSub'>
                      <div>
                        Durchschnittliche Redezeit pro Kopf und Session in
                        Minuten
                      </div>
                      <div style={{ marginTop: '0.5rem' }}>
                        <span className='bold'>Lesebeispiel:</span> In den
                        Sessionen der 51. Legislatur (ab Dezember 2019) hat eine
                        Nationalrätin im Durchschnitt 10,7 Minuten gesprochen.
                      </div>
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='https://datawrapper.dwcdn.net/GKFEE/'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='column special'>
                  <div>
                    <div className='titleBox'>
                      <h4 className='graphicTitle'>
                        So ist die Redezeit im Nationalrat verteilt
                      </h4>
                      <div className='graphicSub'>
                        <div>
                          Anteile der Frauen an der gesamten Redezeit im
                          Nationalrat für ausgewählte Legislaturperioden
                        </div>
                        <div style={{ marginTop: '0.5rem' }}>
                          <span className='bold'>Lesebeispiel:</span> In der 51.
                          Legislatur (ab Dezember 2019) haben Nationalrätinnen
                          40 Prozent der gesamten Redezeit in Anspruch genommen
                          – 11 Prozent mehr als noch in der 46. Legislatur
                          (1999–2003)
                        </div>
                      </div>
                    </div>
                    <div className='graphicBox donut'>
                      <div className='boxWrapper donut'>
                        <div className='iframeBox donut'>
                          <AutofitIFrame
                            src='https://datawrapper.dwcdn.net/D2EdG/'
                            style={{ height: '100%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>3</b>
                <br />
                Gesundheit versus Arbeit? So verändern die Frauen die Themen
              </h4>{' '}
              <p>
                Wie häufig reichen Parlamentarierinnen Vorstösse ein? Und zu
                welchen Themen? Frauen waren in den letzten zwanzig Jahren mit
                durchschnittlich 5,6 Motionen pro Legislatur aktiver als Männer
                (4,8). In der vergangenen Legislatur hat sich das Verhältnis
                erstmals umgekehrt.
              </p>
              <p>
                Über die Zeit zeigt sich ein Muster: Je ausgeglichener das
                Geschlechterverhältnis im Nationalrat ist, desto ausgeglichener
                wird auch das Verhältnis der von Männern und Frauen
                eingereichten Vorstösse. Männer und Frauen setzen mit ihren
                Motionen unterschiedliche Schwerpunkte. In der aktuellen
                Legislatur sind die Frauen aktiver in den Bereichen Gesundheit,
                Umwelt und soziale Fragen, die Männer in den Themen Wirtschaft,
                Staatspolitik und Arbeit.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui container'>
            <div className='ui two column grid doubling stackable'>
              <div className='row'>
                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      So aktiv sind Parlamentarierinnen
                    </h4>
                    <div className='graphicSub'>
                      Durchschnittlich eingereichte Motionen pro Kopf und
                      Geschlecht nach Legislaturperiode
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='https://datawrapper.dwcdn.net/qXX5O/'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                    <div className='source'>
                      Bei der 51. Legislatur (2019–2023) handelt es sich um die
                      aktuelle, noch nicht abgeschlossene Legislatur.
                    </div>
                  </div>
                </div>

                <div className='column special'>
                  <div className='radarChartContainer'>
                    <div className='titleBox'>
                      <h4 className='graphicTitle'>
                        Auf diese Themen setzen Parlamentarierinnen
                      </h4>

                      <div className='graphicSub'>
                        <div>
                          Kategorisierung der eingereichten Motionen der 51.
                          Legislatur nach Thema und Geschlecht
                        </div>
                        <div style={{ marginTop: '0.5rem' }}>
                          <span className='bold'>Lesebeispiel:</span> 35% aller
                          von Frauen eingereichten Motionen sind dem Thema
                          Umwelt zugeordnet. Aber nur 21% der von Männern
                          eingereichten Motionen behandeln das Thema Umwelt.
                        </div>
                      </div>
                    </div>
                    <div className='graphicBox'>
                      <div className='legendContainer'>
                        <div className='legendWoman'>
                          <div className='circle'></div>
                          <div className='legendName'>Frauen</div>
                        </div>
                        <div className='legendMen'>
                          <div className='circle'></div>
                          <div className='legendName'>Männer</div>
                        </div>
                      </div>
                      <div className='question'>
                        <div className='question-container'>
                          <RadarChartRecharts></RadarChartRecharts>
                        </div>
                      </div>
                      <div className='source'>
                        Dargestellt werden die neun meistbehandelten Themen.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Vorstosskönigin bei den Frauen ist aktuell mit 8 Motionen die
                neu gewählte Léonore Porchet (Grüne). Bei den Männern ist
                Jean-Luc Addor (SVP) mit 12 Motionen unverändert Spitzenreiter.
                Zu den aktiven Neupolitikerinnen gehören auch Meret Schneider
                (Grüne), Martina Bircher (SVP) und Delphine Klopfenstein
                Broggini (Grüne) mit jeweils 6–7 Motionen.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <Testimonial
              imageSrc={<Image imgSrc='martina-bircher.png'></Image>}
              quote={
                '«Im Wahlkampf habe ich versprochen, mich in der Ausländer- und Asylpolitik einzusetzen. Entsprechend reiche ich Vorstösse ein.»'
              }
              name={'Martina Bircher'}
              party={'SVP, AG'}
              note={'Aktive Rechtspolitikerin'}
              positionImage={'right'}
              personInfo={
                'Martina Bircher politisiert dezidiert auf SVP-Linie – gegen die «Einwanderung in die Sozialwerke», gegen die «Sozial- und Gesundheitsindustrie», gegen Genderpolitik. Bircher ist eine der aktivsten neu gewählten Parlamentarierinnen, im vergangenen Jahr hat sie 7 Motionen eingereicht. Bircher, auch Gemeinderätin, forderte etwa, dass der Bund die Flüchtlingspauschale an die Gemeinden nicht kürzen solle. Mit Erfolg. '
              }
            />
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Auffällig ist, dass die neu gewählten Parlamentarierinnen auf
                jene Themen setzen, die man als traditionelle Männerthemen
                bezeichnen könnte. Dies ergibt ein Vergleich mit jenen
                Politikerinnen, die schon vor 2019 im Nationalrat sassen: Die
                Themen Wirtschaft, Migration, Landwirtschaft, Energie,
                Sicherheitspolitik oder Steuern werden von den neu gewählten
                Frauen stärker bearbeitet, soziale Fragen, Medien und
                Kommunikation, Staatspolitik oder Strafrecht hingegen weniger.
              </p>
            </div>
          </div>
        </div>

        <div className='ui text container'>
          <div className='column special'>
            <div className='titleBox'>
              <h4 className='graphicTitle'>
                Wer ist im Nationalrat am sichtbarsten?
              </h4>
              <div className='graphicSub'>
                Gezeigt werden Länge und Anzahl der Wortmeldungen sowie
                eingreichte Motionen in der 51. Legislatur.
              </div>
            </div>
            <div className='graphicBox'>
              <div className='boxWrapper scatter'>
                <div className='iframeBox scatter'>
                  <AutofitIFrame
                    src='https://datawrapper.dwcdn.net/46Kht/'
                    style={{ height: '100%' }}
                  />
                </div>
              </div>
              <div className='source scatter'>
                Parlamentarierinnen, die im Herbst 2019 zum ersten Mal in den
                Nationalrat gewählt wurden, sind mit einem Stern abgebildet.
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Hat sich also die politische Kultur fundamental geändert, seit
                im Bundeshaus mehr Frauen mitwirken? Ja, ist Politologe Lukas
                Golder überzeugt. «Frauen sind im Schnitt fähiger für das
                politische System der Schweiz, weil sie eine konkordantere
                Kultur leben. Sie gehen ergebnisoffener aufeinander zu und reden
                miteinander, ohne sich selber in den Vordergrund zu stellen.»
                Deswegen seien sie in der Regel auch bessere Bundesrätinnen,
                sagt Golder. Die Frauenwahl von 2019 habe insofern
                oppositionellen Charakter gehabt: «Viele Wählerinnen und Wähler
                hatten genug vom aggressiven Politstil und von der
                Polarisierung. Sie wollten einen Neuanfang.»
              </p>
            </div>
          </div>
        </div>

        <div className='ui text container'>
          <div className='column special'>
            <div className='titleBox'>
              <h4 className='graphicTitle'>Wer redet am meisten?</h4>
              <div className='graphicSub'>
                Finden Sie heraus, wie aktiv Ihre Vertreterin im Nationalrat in
                der aktuellen Legislatur ist. Klicken Sie auf den jeweiligen
                Spaltentitel für eine andere Sortierung. Wenn Sie im Suchfeld
                «Männer» oder «<span className='purple'>Frauen</span>» bzw.
                «neu» oder «alt» eingeben, können Sie sich die entsprechende
                Auswahl anzeigen lassen.
              </div>
            </div>
            <div className='graphicBox'>
              {/* <div className='boxWrapper Abstimmungen'>
              <div className='iframeBox Abstimmungen'> */}
              <AutofitIFrame
                src='https://datawrapper.dwcdn.net/u9Bpc/'
                // style={{ height: '98%' }}
              />
            </div>
          </div>
          {/* <div className='source'>
              Bei den nicht aufgeführten Fraktionen waren die Vorlagen
              vollständig oder grösstenteils unbestritten. Berücksichtigt wurden
              alle Schluss- und Gesamtabstimmungen der 51. Legislatur.
            </div> */}
          {/* </div>
        </div> */}
        </div>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <Methodic
              text={
                <div>
                  <div className='subtitleMethodic'>Datengrundlage</div>
                  <p>
                    Als Grundlage diente die Datenbank des Parlaments, die über
                    eine öffentliche{' '}
                    <Link href='https://ws.parlament.ch/odata.svc/'>
                      Datenschnittstelle
                    </Link>{' '}
                    abrufbar ist. Folgende Informationen sind verfügbar und
                    wurden für diese Analyse verwendet:
                  </p>

                  <ul>
                    <li>
                      Alle Wortmeldungen im Nationalrat seit 1999, mit
                      Transkription und genauen Anfangs- und Endzeiten
                    </li>
                    <li>
                      Das Abstimmungsverhalten aller Nationalräte und
                      Nationalrätinnen seit 1999
                    </li>
                    <li>
                      Alle eingereichten Motionen im Nationalrat mit
                      Schlagworten seit 1999
                    </li>
                  </ul>
                  <div className='subtitleMethodic'>
                    Vergleich Legislaturen 50/51: Welche Abstimmungen wären
                    anders herausgekommen?
                  </div>

                  <p>
                    Für jede einzelne Abstimmung im Nationalrat während der 50.
                    Legislatur wurde berechnet, wie gross der Anteil Ja-Stimmen
                    der Frauen und der Männer in jeder Fraktion war. Zudem wurde
                    berechnet, wie viele Sitze jede Fraktion auf sich vereint
                    und wie gross der Anteil der Frauen innerhalb einer Fraktion
                    ist. Um herauszufinden, ob Abstimmungen der vorigen
                    Legislatur dank neuer Frauen- und Fraktionsstärke im
                    heutigen Nationalrat anders herausgekommen wären, wurde für
                    jede Abstimmung ein hypothetisches Resultat berechnet: Die
                    effektiven Anteile der Fraktionen und Geschlechter der 50.
                    Legislatur wurden ersetzt durch die jeweiligen Anteile in
                    der jetzigen Legislatur.
                  </p>

                  <p>
                    Es wurden nur Abstimmungen berücksichtigt, bei denen
                    mindestens 180 der 200 Parlamentarierinnen und
                    Parlamentarier effektiv abgestimmt haben. Bei 3535 von 4470
                    Abstimmungen war dies der Fall. Diese Analyse wurde nur für
                    den Nationalrat gemacht, da die Abstimmungen im Ständerat
                    nicht öffentlich sind.
                  </p>
                  <p>
                    Dabei zeigt sich, dass 350 der 3535 Abstimmungen in der
                    Legislatur 50 mit dem neuen Parlament gekippt wären. Wenn
                    man für die Berechnung nur die neue Parteienstärke
                    berücksichtigt, sind es dieselben Abstimmungen, die im neuen
                    Parlament gekippt wären. Das heisst, keine der Abstimmungen
                    wäre nur aufgrund der veränderten Geschlechterverteilung
                    gekippt.
                  </p>
                  <div className='subtitleMethodic'>
                    Geschlechterdiskrepanzen
                  </div>
                  <p>
                    Für alle Schluss- und Gesamtabstimmungen im Nationalrat der
                    51. Legislatur wurde die Differenz der Ja-Anteile der Frauen
                    und der Ja-Anteile der Männer innerhalb der Fraktionen
                    gebildet. Um die Abstimmungen mit der grössten
                    Geschlechterdiskrepanz zu bestimmen, wurde für jede
                    Abstimmung die Summe dieser Differenzen über alle Fraktionen
                    gebildet. Die GLP wurde nicht berücksichtigt, da sie die
                    kleinste Fraktion ist. Es wurden nur Abstimmungen
                    berücksichtigt, bei denen mehr als 90 Prozent der
                    Parlamentsmitglieder eine valide Stimme (Ja/Nein) abgegeben
                    haben.
                  </p>
                  <p>
                    Um die Fraktion mit der grössten Geschlechterdiskrepanz zu
                    bestimmen, wurde wiederum der Mittelwert dieser Differenzen
                    über alle Abstimmungen der jeweilige Fraktion gebildet.
                    Dabei wurden für jede Fraktion nur diejenigen Abstimmungen
                    berücksichtigt, bei denen mehr als 90 Prozent der Mitglieder
                    der jeweiligen Fraktion eine valide Stimme (Ja/Nein)
                    abgegeben haben.
                  </p>
                  <div className='subtitleMethodic'>Redezeiten</div>
                  <p>
                    In der Datenbank sind der Beginn und das Ende jeder
                    Wortmeldung aufgeführt. Daraus lässt sich die Länge der
                    Wortmeldung ableiten. Es werden alle Wortmeldungen von
                    Parlamentarierinnen und Parlamentariern im Nationalrat
                    berücksichtigt, wobei die Nationalratspräsidentin in der
                    jeweiligen Session nicht berücksichtigt wird.
                  </p>
                  <div className='subtitleMethodic'>Motionen</div>
                  <p>
                    Die Auswertung der Vorstösse basiert auf allen von
                    Nationalratsmitgliedern eingereichten Motionen der letzten
                    fünf Legislaturperioden. Motionen gehören zu den
                    meistgenutzten parlamentarischen Vorstössen. Sie beauftragen
                    den Bundesrat, Gesetzesentwürfe oder Massnahmen
                    auszuarbeiten. Motionen eignen sich deshalb, um die
                    parlamentarische Arbeit eines Nationalratsmitglieds zu
                    analysieren. Jede dieser Motionen ist in der Datenbank des
                    Parlaments mit mindestens einem Themen-Schlagwort versehen.
                    Anhand der Schlagworte lässt sich ermitteln, welche
                    Themenschwerpunkte Parlamentarierinnen und Parlamentarier
                    setzen.
                  </p>
                  <p>
                    Mehr Details zur Methodik finden Sie auf unserem{' '}
                    <Link href='https://github.com/tamedia-ddj/1_Jahr_Frauenparlament'>
                      Github Account
                    </Link>
                    .
                  </p>
                </div>
              }
            />
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='section-teaser'>
              <h5>50 Jahre Frauenstimmrecht</h5>
              <Link
                href={
                  'https://' +
                  parseHostname().publicationDomain +
                  '/frauenstimmrecht'
                }
                hideIcon
              >
                <img
                  src={require('../../images/50_jahre_frauenstimmrecht.jpg')}
                  className='ui image fluid'
                />
              </Link>
            </div>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          hidePortfolioTeaser
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie unterhaltsam war er?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            ['Text und Recherche', 'Salome Müller, Raphaela Birrer'],
            ['Datenanalyse', 'Patrick Meier, Sven Cornehls'],
            ['Digitale Umsetzung', 'Patrick Vögeli'],
            [
              'Quellen',
              '<a href="https://ws.parlament.ch/odata.svc/" target="_blank">Datenschnittstelle parlament.ch</a>, Bundesamt für Statistik'
            ],
            ['Parteifarben-Definition', 'Angelo Zehr, SRF Data'],
          ]}
        />
      </div>
    )
  }
}
